import { postJson } from 'utils/fetch';

export const geocodeAddress = address =>
  postJson('/pco-manager/geocode', JSON.stringify(address));

export const geocodeString = request =>
  postJson(
    '/pco-manager/geocode-string',
    JSON.stringify({
      request: request,
    })
  );



// WEBPACK FOOTER //
// ./src/services/geocoding.js